import {useEffect,useState,useCallback} from 'react';
import {getApiUrl} from '../config/serverEndpoint';
import {accountHeaders} from '../utils/accountFetch';
export default function useDuelSeries(username, enabled=true) {
 const [data,setData]=useState(null),[error,setError]=useState(''),[revision,setRevision]=useState(0);
 const refresh=useCallback(()=>setRevision(v=>v+1),[]);
 useEffect(()=>{
  setData(null);setError('');
 },[username,enabled]);
 useEffect(()=>{
  if(!enabled||!username)return;
  let active=true,busy=false;const controller=new AbortController();
  const load=async()=>{
   if(busy||document.visibilityState==='hidden')return;busy=true;
   try {
    const response=await fetch(getApiUrl(`/duels?username=${encodeURIComponent(username)}`),{headers:accountHeaders(),signal:controller.signal,cache:'no-store'});
    if(!response.ok)throw Error();const body=await response.json();
    if(!Array.isArray(body.series)||!body.statistics)throw Error();
    if(active){setData(body);setError('');for(const series of body.series)if(series.phase==='playing')window.dispatchEvent(new CustomEvent('kelimo-duel-round-available',{detail:series}));}
   }catch(e){if(active&&e.name!=='AbortError')setError('Düellolar yüklenemedi. Bağlantını kontrol edip tekrar dene.');}finally{busy=false;}
  };
  load();const timer=setInterval(load,5000);
  const events=['kelimo-duel-updated','kelimo-player-name-updated','online','focus'];events.forEach(e=>window.addEventListener(e,load));document.addEventListener('visibilitychange',load);
  return()=>{active=false;controller.abort();clearInterval(timer);events.forEach(e=>window.removeEventListener(e,load));document.removeEventListener('visibilitychange',load);};
 },[username,enabled,revision]);
 return {data,error,refresh};
}
